import { Permissions } from '../../../services/OAuth/enums.ts';

export const PLAYER_PRIVILEGES = [
  Permissions.GetUser,
  Permissions.PatchUser,
  Permissions.GetTransaction,
  Permissions.PostTransaction,
  Permissions.PostGame,
  Permissions.GetGame,
  Permissions.GetAccount,
  Permissions.GetTransactionRequest,
  Permissions.PostTransactionRequest,
  Permissions.GetTransactionRequestResponse,
  Permissions.PostTransactionRequestResponse,
];

export const RESERVED_DISPLAY_NAMES = [
  'thebank',
  'freeparking',
  'absurdprofit',
];